export default __webpack_public_path__ + "static/media/open.9cdc9333.svg";